import { Component, StrictMode } from "react";
import type { ErrorInfo, ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("RAS portal render failure", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "24px", background: "#f3f7fb" }}>
        <section style={{ maxWidth: 560, padding: 32, borderRadius: 24, background: "white", boxShadow: "0 18px 60px rgba(7, 21, 39, .12)" }}>
          <p style={{ color: "#168cf1", fontWeight: 800, letterSpacing: ".12em" }}>RAS SPORTS ENGINE</p>
          <h1>Vamos recuperar seu dashboard.</h1>
          <p>Seus dados e sua análise continuam salvos. Recarregue a área do atleta para retomar.</p>
          <button type="button" onClick={() => window.location.reload()}>Recarregar dashboard</button>
        </section>
      </main>
    );
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
